import axios from 'axios'

// 根据环境确定基础URL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境使用代理前缀
    return ''
  } else if (process.env.NODE_ENV === 'production') {
    // 生产环境
    return process.env.VUE_APP_API_BASE_URL || 'https://gualan.ntsteel.top'
  }
  return ''
}

// 创建axios实例
const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    
    // 登录、注册、海康开放平台接口不需要业务token
    if (config.url === '/api/user/login' || config.url === '/api/User/login' || config.url === '/api/User/register' ||
        (config.url && config.url.includes('open-api.hikiot.com'))) {
      return config
    }
    
    // 除了登录注册接口，其他所有接口都需要token
    if (token) {
      // 使用Authorization Bearer方式传递token
      config.headers.token = token
    } else {
      // 如果没有token，可以跳转到登录页面或抛出错误
      console.warn('请求需要token但未找到，请先登录')
      // 可以选择跳转到登录页面
      // window.location.href = '/login'
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    // 统一处理返回的msg，如果接口返回了msg，可以通过response.data.msg获取
    const data = response.data
    if (data && data.msg) {
      // msg信息可以在组件中通过返回的data获取
      // 这里不做处理，让组件自行处理msg
    }
    return response
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('userinfo')
      // 可以在这里跳转到登录页面
      window.location.href = '/'
    }
    
    // 处理其他错误，如果有返回msg，可以通过error.response.data.msg获取
    if (error.response && error.response.data && error.response.data.msg) {
      // 错误信息可以在组件中通过error.response.data.msg获取
    }
    
    return Promise.reject(error)
  }
)

// API接口定义
const api = {
  // 用户登录接口
  login: (data) => {
    return request({
      url: '/api/user/login',
      method: 'post',
      data: {
        account: data.account,
        password: data.password
      }
    })
  },
  
  // 获取用户信息接口
  getUserInfo: () => {
    return request({
      url: '/api/user/userinfo',
      method: 'get'
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 更新用户信息接口
  updateUserProfile: (data) => {
    return request({
      url: '/api/user/profile',
      method: 'post',
      data: {
        nickname: data.nickname,
        avatar: data.avatar
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 修改密码接口
  updatePassword: (data) => {
    return request({
      url: '/api/user/updatepwd',
      method: 'post',
      data: {
        password: data.password, // 旧密码
        newPassword: data.newPassword, // 新密码
        rePassword: data.rePassword // 确认密码
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 文件上传接口
  uploadFile: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    
    return request({
      url: '/api/common/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 设备相关接口
  // 获取设备状态统计
  getDeviceStatusNum: () => {
    return request({
      url: '/api/device/getStatusNum',
      method: 'get'
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 添加设备
  addDevice: (data) => {
    return request({
      url: '/api/device/add',
      method: 'post',
      data: {
        deviceId: data.deviceId, // 设备编号
        type: data.type // 设备类型：1=摄像头, 2=录音
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 删除设备
  deleteDevice: (id) => {
    return request({
      url: '/api/device/delete',
      method: 'get',
      params: {
        id: String(id) // 设备ID
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 编辑设备
  updateDevice: (data) => {
    return request({
      url: '/api/device/update',
      method: 'post',
      data: {
        deviceId: data.deviceId, // 设备编号（不可变）
        type: data.type // 设备类型：1=摄像头, 2=录音
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 获取设备列表
  getDeviceList: (params) => {
    return request({
      url: '/api/device/lst',
      method: 'get',
      params: {
        page: params.page || '1', // 第几页
        limit: params.limit || '20', // 每页几条
        keyword: params.keyword || '', // 关键词检索
        status: params.status || '', // 状态【0=离线, 1=空闲中, 2=工作中】
        type: params.type || '0' // 设备类型【0=全部, 1=摄像头, 2=录音】
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 获取设备详情
  getDeviceDetail: (id) => {
    return request({
      url: '/api/device/detail',
      method: 'get',
      params: {
        id: String(id) // 设备ID
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 更新设备阈值
  updateDeviceThreshold: (data) => {
    return request({
      url: '/api/device/threshold',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        threshold: String(data.threshold) // 阈值
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 设备截图接口
  captureDevice: (data) => {
    return request({
      url: '/api/device/capture',
      method: 'post',
      data: {
        id: String(data.id) // 设备ID（详情返回的id字段）
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 视频设备控制接口
  controlVideo: (data) => {
    return request({
      url: '/api/device/controlVideo',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        action: String(data.action) // 操作类型：0-停止，1-启动
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 录音设备控制接口
  segmentRecord: (data) => {
    return request({
      url: '/api/device/segmentRecord',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        action: String(data.action) // 操作类型：0-停止，1-启动
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 海康开放平台：应用授权凭证换取 appAccessToken
  exchangeAppToken: (data) => {
    return request({
      url: 'https://open-api.hikiot.com/auth/exchangeAppToken',
      method: 'post',
      data: {
        appKey: data.appKey,
        appSecret: data.appSecret
      }
    })
  },

  // 海康开放平台：申请授权码，返回 authCode 用于后续换取 userAccessToken
  applyAuthCode: (data) => {
    return request({
      url: 'https://open-api.hikiot.com/auth/third/applyAuthCode',
      method: 'post',
      data: {
        appKey: data.appKey,
        userName: data.userName,
        password: data.password,
        redirectUrl: data.redirectUrl
      }
    })
  },

  // 海康开放平台：authCode 换取 userAccessToken，需在请求头传入 App-Access-Token
  code2Token: (appAccessToken, authCode) => {
    return request({
      url: 'https://open-api.hikiot.com/auth/third/code2Token',
      method: 'post',
      headers: {
        'App-Access-Token': appAccessToken
      },
      data: { authCode }
    })
  },

  // 海康开放平台：获取设备取流 token，需在请求头传入 App-Access-Token、User-Access-Token，返回 httpUrlToken 作为 ezAccessData
  getDeviceToken: (appAccessToken, userAccessToken) => {
    return request({
      url: 'https://open-api.hikiot.com/device/v1/token/ops/get',
      method: 'get',
      headers: {
        'App-Access-Token': appAccessToken,
        'User-Access-Token': userAccessToken
      }
    })
  },

  // 获取海康开放平台 token（appAccessToken、userAccessToken、opsToken），替代官方三个接口，存储本地避免重复调用
  getHikiopInfo: () => {
    return request({
      url: '/api/device/getHikiopInfo',
      method: 'get'
    })
  },

  // 初始化资源（watch 页调用，返回 resourcesData、tokensData、capacitysData，存储本地供后续使用）
  initResource: (params) => {
    const deviceSerial = (params.deviceSerial && String(params.deviceSerial).trim()) || 'GL7060735'
    const channelNo = params.channelNo ?? 1
    return request({
      url: '/api/device/initResource',
      method: 'get',
      params: {
        deviceSerial,
        channelNo
      }
    })
  },

  // 获取设备摄像头列表（传入设备id，返回 sn、channel 供后期查询）
  getDeviceCamera: (id) => {
    return request({
      url: '/api/device/camera',
      method: 'get',
      params: {
        id: String(id)
      }
    })
  },
  
  // 设备考勤数据接口
  getDeviceAttendance: () => {
    return request({
      url: '/api/device/attendance',
      method: 'get'
    })
  },
  
  // 筛选：设备名称 / 设备类型 / 传感器 下拉选项
  getDeviceOptions: (params) => {
    return request({
      url: '/api/device/options',
      method: 'get',
      params: {
        id: params.id != null && params.id !== '' ? String(params.id) : '',
        page: String(params.page || '1')
      }
    })
  },

  // 历史数据列表：服务端分页（固定每页 14 条）
  getDeviceHistoryList: (params) => {
    return request({
      url: '/api/device/history_lst',
      method: 'get',
      params: {
        id: params.id != null && params.id !== '' ? String(params.id) : '',
        page: String(params.page || '1'),
        limit: String(params.limit || '14'),
        wd: params.wd != null ? String(params.wd) : '',
        type: params.type != null ? String(params.type) : '',
        sensor: params.sensor != null ? String(params.sensor) : '',
        start_time: params.start_time != null ? String(params.start_time) : '',
        end_time: params.end_time != null ? String(params.end_time) : ''
      }
    })
  },

  // 历史数据导出（返回文件 URL）
  exportDeviceHistory: (params) => {
    return request({
      url: '/api/device/history_export',
      method: 'get',
      params: {
        id: params.id != null && params.id !== '' ? String(params.id) : ''
      }
    })
  },

  // 报警列表：支持全量统计与分页列表
  getDeviceAlarmList: (params) => {
    const baseParams = {
      id: params.id != null && params.id !== '' ? String(params.id) : '',
      wd: params.wd != null ? String(params.wd) : '',
      type: params.type != null ? String(params.type) : '',
      sensor: params.sensor != null ? String(params.sensor) : '',
      start_time: params.start_time != null ? String(params.start_time) : '',
      end_time: params.end_time != null ? String(params.end_time) : ''
    }
    const queryParams = params && params.omitLimit
      ? baseParams
      : {
          ...baseParams,
          page: String(params.page || '1'),
          limit: String(params.limit || '14')
        }
    return request({
      url: '/api/device/alarm_lst',
      method: 'get',
      params: queryParams
    })
  },

  // 报警导出（返回文件 URL）
  exportDeviceAlarm: (params) => {
    return request({
      url: '/api/device/alarm_export',
      method: 'get',
      params: {
        id: params.id != null && params.id !== '' ? String(params.id) : ''
      }
    })
  },

  // 获取设备文件列表接口
  getDeviceFileList: (params) => {
    return request({
      url: '/api/device/file_list',
      method: 'get',
      params: {
        deviceId: String(params.deviceId), // 设备ID（必选）
        page: String(params.page || '1'), // 第几页（必选）
        limit: String(params.limit || '20'), // 每页几条（必选）
        keyword: params.keyword || '', // 关键词检索（可选）
        type: params.type || '0', // 文件类型【0=全部, 1=图片, 2=录像, 3=声音】（可选）
        startTime: params.startTime || '', // 筛选开始时间（可选）
        endTime: params.endTime || '' // 筛选结束时间（可选）
      }
      // token会通过请求拦截器自动添加到headers中
    })
  }
}

// 导出默认实例和api对象
export default request
export { api }
